import {
    FETCH_SKILLS_START,
    FETCH_SKILLS_SUCCESS,
    FETCH_SKILLS_ERROR
} from '../../actions/common/skillsAction';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    skills: JSON.parse(localStorage.getItem('skills')) || []
};

const skillsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SKILLS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SKILLS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, skills: action.skills };
        }
        case FETCH_SKILLS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default skillsReducer;
